export default __webpack_public_path__ + "static/media/4.706e3dc3.jpg";